import { api } from '../api';

const libraryApi = api.injectEndpoints({
    endpoints: (build) => ({
        getList: build.mutation({
            query: (filters) => ({
                url: `/library/list${filters && filters}`,
                method: 'GET'
            })
        })
    })
})

export const { useGetListMutation } = libraryApi;
